import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import AdminActionsPopupNew from "../../admin-actions-popup/AdminActionsPopupNew";
import {
  addSelectedRole,
  deleteSelectedRole,
} from "../../../../../redux/admin/roles/roles-actions";
import { createStructuredSelector } from "reselect";
import { selectSelectedRoles } from "../../../../../redux/admin/roles/roles-selector";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import "./role-row-new.styles.scss";

const RoleRowNew = ({
  data,
  privileges,
  addSelectedRow,
  deleteSelectedRow,
  selectedRows,
}) => {
  const [showAdminActionsPopup, setShowAdminActionsPopup] = useState(false);

  let history = useHistory();

  const onEdit = () => {
    if (!privileges.Role.Edit === false) {
      history.push(`/admin/roles/edit/${data.Id}`);
    }
  };

  const onArchive = () => {
    if (!privileges.Role.Delete === false) {
      setShowAdminActionsPopup(true);
    }
  };

  const onSelect = (e) => {
    if (e.target.checked) {
      addSelectedRow(data.Id);
    } else {
      deleteSelectedRow(data.Id);
    }
  };

  return (
    <tr className="role-row-1">
      <td className="th-checkbox-col">
        <Form.Check
          type={"checkbox"}
          disabled={!privileges.Role.Delete}
          onClick={(e) => {
            onSelect(e);
          }}
          checked={selectedRows.includes(data.Id)}
        />
      </td>
      <td className="data-text role-name">{data.Name}</td>
      <td className="data-text role-description">
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="bottom"
          delay={{ show: 150, hide: 150 }}
          overlay={
            <Popover id="description-popover" className="custom-popover">
              <Popover.Content>
                {data.Description ? data.Description : ""}
              </Popover.Content>
            </Popover>
          }
        >
          <div className="text-wrapper">
            <span className="text-content">{data.Description ? data.Description : ""}</span>
          </div>
        </OverlayTrigger>
      </td>
      <td className="data-text role-department">{data.CompanyName}</td>
      <td className="admin-row-status role-status">
        {data.Active ? (
          <div className="status active">Active</div>
        ) : (
          <div className="status inactive">Inactive</div>
        )}
      </td>
      <td className="admin-row-action-buttons role-actions">
        <Button
          disabled={!privileges.Role.Delete}
          className={`btn-icon1 ${
            !privileges.Role.Delete === false
              ? "archive-icon1"
              : "archive-icon1-disabled"
          }`}
          onClick={() => onArchive()}
          title="Archive"
        />
        <Button
          disabled={!privileges.Role.Edit}
          className={`btn-icon1 ${
            !privileges.Role.Edit === false
              ? "edit-icon1"
              : "edit-icon1-disabled"
          }`}
          onClick={() => onEdit()}
          title="Edit"
        />
      </td>
      {showAdminActionsPopup ? (
        <AdminActionsPopupNew
          type={"role"}
          name={data.Name}
          selectedIDs={[data.Id]}
          showAdminActionsPopup={showAdminActionsPopup}
          setShowAdminActionsPopup={setShowAdminActionsPopup}
        />
      ) : (
        <></>
      )}
    </tr>
  );
};

const mapState = createStructuredSelector({
  selectedRows: selectSelectedRoles,
});

const mapDispatch = (dispatch) => ({
  addSelectedRow: (id) => dispatch(addSelectedRole(id)),
  deleteSelectedRow: (id) => dispatch(deleteSelectedRole(id)),
});

RoleRowNew.propTypes = {
  data: PropTypes.object.isRequired,
  privileges: PropTypes.object.isRequired,
  addSelectedRow: PropTypes.func.isRequired,
  deleteSelectedRow: PropTypes.func.isRequired,
  selectedRows: PropTypes.array.isRequired,
};
export default connect(mapState, mapDispatch)(RoleRowNew);
